import * as React from 'react';

import { ApplicationContext, AppContext } from '../../context/Contexts';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import { AppActionCreators, ApplicationState, AppState } from '../../store';
import { ICaseService } from '../../services/Interfaces/ICaseService';
import { ScaleLoader } from 'react-spinners';
import { Button, Grid, IconButton, List, ListItem } from '@material-ui/core';
import { isNullOrUndefined } from 'util';
import { withRouter } from 'react-router';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import AppointmentNewInNotificationItem from './AppointmentNewInNotificationItem';
import { NotificationType, UserNotification } from '../../interfaces/UserNotificationsUpdate';

export interface ExternalAppointmentNewInNotificationProps {
  onClick?: () => void;
}

type AppointmentNewInNotificationProps = { appState: AppState } & typeof AppActionCreators &
  RouteComponentProps &
  ExternalAppointmentNewInNotificationProps;

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IAppointmentNewInNotificationState {}

class AppointmentNewInNotification extends React.PureComponent<
  AppointmentNewInNotificationProps,
  IAppointmentNewInNotificationState
> {
  private caseService!: ICaseService;
  private notifications: UserNotification[] = [];

  static contextType = ApplicationContext;

  state = {} as IAppointmentNewInNotificationState;

  public render() {
    this.caseService = (this.context as AppContext).caseService;
    this.notifications = this.props.appState.userNotifications.filter((notification: UserNotification) => notification.type === NotificationType.Appointment);  

    return (
      <React.Fragment>
          {this.notifications.length === 0 ? (
            <div className="text-center">
              <div className="avatar-icon-wrapper  m-0">
                <div className="d-inline-flex justify-content-center p-0 rounded-circle avatar-icon-wrapper  m-0 d-140">
                  <FontAwesomeIcon
                    icon={['far', 'calendar']}
                    className="d-flex align-self-center display-1 "
                  />              
                </div>
              </div>
            </div>
          ) : null}

        {this.notifications.length !== 0  ? (
          <List className="p-0">
            {this.notifications.map((item, index) => (
              <ListItem divider key={index} style={{ backgroundColor: !item.read ? '#f7f7fc' : 'inherit' }}>
                <AppointmentNewInNotificationItem                    
                    {...this.props}                    
                    item = {{
                        dateCreated: item.dateCreation ? new Date(item.dateCreation) : new Date(),
                        type: 'appointment',
                        entity: item,
                        isInPopup: false
                      }}
                    index= {index}
                  >
                </AppointmentNewInNotificationItem>
              </ListItem>
            ))}
          </List>
        ) : null}
      </React.Fragment>
    );
  }
}

const mergeProps = (
  stateProps: any,
  dispatchProps: any,
  ownProps: ExternalAppointmentNewInNotificationProps
) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps
});

export default connect(
  (state: ApplicationState) => ({
    caseSettingsState: state.caseSettings,
    appState: state.app
  }),
  AppActionCreators,
  mergeProps
)(withRouter(AppointmentNewInNotification as any));
